<template>
  <div
    class="login-form"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div>
      <div class="d-flex justify-between align-center mb-3 flex-wrap">
        <span class="register-heading" :style="getPrimaryColor">
          Email Verification!
        </span>
        <div class="nav-link text-right">
          <router-link to="/signin" class="fw-bold" :style="getPrimaryColor" v-if="!isVerified">
            Back
          </router-link>
        </div>
      </div>

      <div class="divider">
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <div class="content">
        <p class="text-muted opacity-80 fs-7">
          A Verification mail has been sent to your email account.Please check
          your inbox to verify.
        </p>
        <div>
          <el-form
            :model="verify_email"
            ref="verify_email"
            class="log-form"
            @keyup.enter.prevent="submitForm('verify_email')"
          >
            <el-form-item label="Email Address">
              <el-input
                v-model="verify_email.email"
                readonly
                placeholder="Enter Email Address"
              ></el-input>
              <p class="error" v-if="getErrors && getErrors.email">
                {{ getErrors.email }}
              </p>
            </el-form-item>
            <el-form-item label="Verification Code (OTP)">
              <!-- :readonly="$route.query.vc?true:false" -->
              <el-input
                v-model="verify_email.verification_code"
                placeholder="Enter Verification Code"
              ></el-input>
              <p class="error" v-if="getErrors && getErrors.verification_code">
                {{ getErrors.verification_code }}
              </p>
            </el-form-item>
            <el-form-item class="mt-5">
              <el-button
                type="primary"
                class="type-2 w-100 fs-6"
                @click="submitForm('verify_email')"
                :loading="submitLoading"
                :disabled="!verify_email.verification_code.length"
                style="background-color: #f754a2"
                >Verify</el-button
              >
              <p class="error" v-if="getErrors && getErrors.critical_error">
                {{ getErrors.critical_error }}
              </p>
            </el-form-item>
            <p class="mb-0 text-muted fs-8 text-center">
              <i class="el-icon-lock"></i>
              Your Info is safely secured
            </p>

            <p class="mb-0 text-muted fs-8 text-center" v-if="!isVerified">
              <el-button
                @click="resendVerificationMail()"
                type="text"
                :loading="resendSubmitLoading"
              >
                <i class="el-icon-s-promotion"></i> Resend Verification
              </el-button>
            </p>

            <p class="mb-0 text-muted fs-8 text-center" v-else>
              <router-link to="/signin">
                <i class="el-icon-back"></i> Back to Sign In
              </router-link>
            </p>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WhiteLabelConfig from "../../config/app";
import CustomizationLayer from "@/mixins/CustomizationLayer";
export default {
  name: "UserVerify",
  mixins: [CustomizationLayer],
  data() {
    return {
      isVerified: false,
      applicationSettings: {},
      submitLoading: false,
      resendSubmitLoading: false,
      verify_email: {
        email: "",
        verification_code: "",
        company_id: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "Email is required",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Invalid Email",
            trigger: "blur",
          },
        ],
        verification_code: [
          {
            required: true,
            message: "Verification Code is required",
            trigger: "blur",
          },
        ],
      },
    };
  },

  watch: {
    "getErrors.critical_error"(newVal) {
      if (newVal === "This workspace is already active") {
        this.isVerified = true;
        this.criticalErrorMessage = "";
      } else if (newVal) {
        this.criticalErrorMessage = newVal;
      }
    },
  },

  mounted() {
    this.applicationSettings = WhiteLabelConfig;
    this.$store.dispatch("auth/reset");
    this.verify_email.email = this.$route.query.email;
    if (this.$route.query.company) {
      this.verify_email.company_id = this.$route.query.company;
    }
    if (this.$route.query.vc) {
      this.verify_email.verification_code = this.$route.query.vc;
    }
  },
  computed: {
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("auth", [
      "getVerificationStatus",
      "getResendVerificationEmail",
    ]),
  },
  created() {
    this.$store.commit("errors/setErrors", null, { root: true });
    this.verify_email.email = this.$route.query.email;
    if (this.$route.query.company) {
      this.verify_email.company_id = this.$route.query.company;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.verify();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    async resendVerificationMail() {
      try {
        this.resendSubmitLoading = true;
        let email = this.verify_email.email.toLowerCase();

        if (this.$route.query.vc) {
          await this.$store.dispatch("auth/resendInviteEmailToUser", {
            email: email,
            company: this.verify_email.company_id,
          });
        } else {
          await this.$store.dispatch("auth/resendVerificationEmailToUser", {
            email: email,
            company: this.verify_email.company_id,
          });
        }

        if (this.getResendVerificationEmail) {
          this.$notify.success({
            title: "Success",
            message: "Verification mail sent to your email",
          });
        }
        this.resendSubmitLoading = false;
      } catch (err) {
        this.resendSubmitLoading = false;
        console.log("resendVerificationMail", err);
        this.$notify.error({
          title: "Error",
          message: "Error at sending verification mail",
        });
      }
    },
    async verify() {
      try {
        this.submitLoading = true;
        let data = {
          email: this.verify_email.email.toLowerCase(),
          verification_code: this.verify_email.verification_code,
        };
        await this.$store.dispatch("auth/verifyAccount", data);

        if (this.getVerificationStatus) {
          this.$notify.success({
            title: "Success",
            message: "Verified successfully",
          });
          this.isVerified = true;
          this.$router.push("/signin");
        }
        this.submitLoading = false;
      } catch (err) {
        this.submitLoading = false;
        console.log(err);
      }
    },
  },
};
</script>
